import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  createListCustomer,
  createSavereceipt,
  getCustomerAddressList,
  getDebitNotesList,
  getDeliveryMethodList,
  getDocumentSetList,
  getLanguageList,
  getListCountry,
  getListCurrency,
  getListCustomerList,
  getListSalesmenList,
  getMaturityDatesList,
  getPaymentMethodList,
  getProductPriceClassList,
  updateReceipt,
  viewReceipt,
} from "../../services/MoloniServices";
import Select from "react-select";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  getCommonSearchList,
  getInvoiceList,
} from "../../services/settingsServices";

const AddReceipt = () => {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { t } = useTranslation();
  const [btnLoader, setBtnLoader] = useState(false);

  const [receiptData, setReceiptData] = useState({
    id: "",
    moloni_id: "",
    date: new Date().toISOString().split("T")[0],
    document_set_id: "",
    customer_id: "",
    alternate_address_id: "",
    associated_documents: [],
    payments: [],
    related_documents_notes: "",
    exchange_currency_id: "",
    exchange_rate: "",
    notes: "",
    status: 0,
    net_value: "",
    associate_document_type: "",
    alternate_address: [],
  });

  let errorsObj = {
    date: "",
    document_set_id: "",
    customer_id: "",
    net_value: "",
    associated_documents: "",
  };
  const [errors, setErrors] = useState(errorsObj);
  const [documentSetList, setDocumentSetList] = useState([]);
  const [customerList, seCustomerList] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState([]);
  const [receiptDetials, setReceiptDetails] = useState("");
  const [exchangeCurrList, setExchangeCurrList] = useState([]);
  const [assocDataList, setAssocDataList] = useState([]);
  const [alternateAddressList, setAlternateAddressList] = useState([]);
  const [paymentErrors, setPaymentErrors] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [invoiceType, setInvoiceType] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [customerModel, setCustomerModel] = useState(false);
  const [activeCustomerTab, setActiveCustomerTab] = useState("1");
  const [filterList, seFilterList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [altForm, setAltForm] = useState({
    description: "",
    code: "",
    address: "",
    zip_code: "",
    city: "",
    country: "",
    email: "",
    phone: "",
    fax: "",
    contact_person: "",
  });

  const [customerData, setCustomerData] = useState({
    id: "",
    vat: "",
    number: "",
    name: "",
    language_id: "",
    qty_copies_document: "",
    notes: "",
    country_id: "",
    address: "",
    zip_code: "",
    city: "",
    email: "",
    website: "",
    phone: "",
    fax: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    discount: "",
    credit_limit: "",
    payment_method_id: "",
    delivery_method_id: "",
    maturity_date_id: "",
    field_notes: "",
    salesman_id: "",
    price_class_id: "",
    payment_day: "",
    document_type_id: "",
    moloni_id: "",
    contact_person: "",
    contact_notes: "",
    customer_iva: 0,
    series_id: "",
    price_id: "",
  });

  const [languageList, setLanguageList] = useState([]);
  const [paymentMethodList, setPaymentMethodList] = useState([]);
  const [maturityDatesList, setMaturityDatesList] = useState([]);
  const [priceClassList, setPriceClassList] = useState([]);
  const [salesmenList, setSalesmenDatesList] = useState([]);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [deliveryMethodList, setDeliveryMethodList] = useState([]);
  const [editIndex, setEditIndex] = useState(null);

  const handleSearch = (value) => {
    setSearch(value);
  };

  const handleSelectCustomer = (item) => {
    setSearch(item.name);
    setSelectedCustomerId(item.moloni_id);
  };

  const handleAltChange = (e) => {
    setAltForm({
      ...altForm,
      [e.target.name]: e.target.value,
    });
  };

  const resetAltForm = () => {
    setAltForm({
      description: "",
      code: "",
      address: "",
      zip_code: "",
      city: "",
      country: "",
      email: "",
      phone: "",
      fax: "",
      contact_person: "",
    });
    setEditIndex(null);
  };

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDeliveryMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDeliveryMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListSalesmenList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setSalesmenDatesList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCountry(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setCountryList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getMaturityDatesList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setMaturityDatesList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getProductPriceClassList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].title,
          });
        }

        setPriceClassList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getPaymentMethodList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setPaymentMethodList(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getLanguageList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].language_id,
            label: response.data[i].title,
          });
        }

        setLanguageList(list);
      })
      .catch((err) => {});
  }, []);

  const editAlternateAddress = (index) => {
    setAltForm(receiptData.alternate_address[index]);
    setEditIndex(index);
  };

  const deleteAlternateAddress = (index) => {
    const updated = receiptData.alternate_address.filter((_, i) => i !== index);

    setReceiptData({
      ...receiptData,
      alternate_address: updated,
    });
  };

  const handleCustomerCloseModel = () => {
    setCustomerModel(false);
  };

  const saveAlternateAddress = () => {
    if (
      !altForm.description ||
      !altForm.code ||
      !altForm.address ||
      !altForm.zip_code ||
      !altForm.city ||
      !altForm.country
    ) {
      toast.error("Please fill all required fields");
      return;
    }

    let updatedList = [...receiptData.alternate_address];

    if (editIndex !== null) {
      updatedList[editIndex] = altForm;
    } else {
      updatedList.push(altForm);
    }

    setReceiptData({
      ...receiptData,
      alternate_address: updatedList,
    });

    resetAltForm();
  };

  useEffect(() => {
    if (uuid) {
      let data = { id: uuid };
      viewReceipt(data)
        .then((response) => {
          setReceiptDetails(response.data.data);
        })
        .catch((err) => {
          navigate("/receipts");
          toast.error(Utils.getErrorMessage(err));
        });
    }
  }, [uuid]);

  useEffect(function () {
    let data = {
      limit: 10,
      page: 1,
      search: "",
      type: "m_receipt",
    };
    getCommonSearchList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setInvoiceType(list);
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    if (receiptDetials) {
      setReceiptData({
        id: receiptDetials?.id,
        moloni_id: receiptDetials?.document_id,
        date: receiptDetials?.date,
        document_set_id: receiptDetials?.document_set_id,
        customer_id: receiptDetials?.customer_id,
        alternate_address_id: receiptDetials?.alternate_address_id,
        associated_documents: receiptDetials?.associated_documents,
        related_documents_notes: receiptDetials?.related_documents_notes,
        exchange_currency_id: receiptDetials?.exchange_currency_id,
        exchange_rate: receiptDetials?.exchange_rate,
        notes: receiptDetials?.notes,
        status: receiptDetials?.status,
        net_value: receiptDetials?.net_value,
        payments: receiptDetials?.payments,
        associate_document_type: receiptDetials?.associate_document_type,
      });
      setSelectedCustomerId(receiptDetials?.customer_id);
    }
  }, [receiptDetials]);

  useEffect(
    function () {
      let data = {
        limit: 20,
        page: 1,
        search: search ? search : "",
      };
      getListCustomerList(data)
        .then((response) => {
          seCustomerList(response.data.data);
          if (search) {
            seFilterList(response.data.data);
          }
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
        });
    },
    [search],
  );

  useEffect(() => {
    if (!selectedCustomerId) {
      return;
    }

    if (Number(receiptData.associate_document_type) === 1) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        created_from: 1,
        customer_id: selectedCustomerId,
      };

      getInvoiceList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }

    if (Number(receiptData.associate_document_type) === 2) {
      let data = {
        limit: 20,
        page: 1,
        search: "",
        customer_id: selectedCustomerId,
      };

      getDebitNotesList(data)
        .then((response) => {
          let list = response.data.data.map((item) => ({
            value: item.document_id,
            label: `${item.entity_name} (${item.number})`,
            net_value: item.net_value,
            customer_id: item.customer_id,
          }));
          setAssocDataList(list);
        })
        .catch((err) => toast.error(Utils.getErrorMessage(err)));
    }
  }, [receiptData, receiptData?.associate_document_type]);

  useEffect(
    function () {
      if (receiptData?.customer_id) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          customer_id: receiptData?.customer_id,
        };
        getCustomerAddressList(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].moloni_id,
                label: response.data[i].address,
              });
            }

            setAlternateAddressList(list);
          })
          .catch((err) => {
            toast.error(Utils.getErrorMessage(err));
          });
      }
    },
    [receiptData],
  );

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getListCurrency(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setExchangeCurrList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  useEffect(function () {
    let data = {
      limit: 20,
      page: 1,
      search: "",
    };
    getDocumentSetList(data)
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].moloni_id,
            label: response.data[i].name,
          });
        }

        setDocumentSetList(list);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  }, []);

  const handleAddAssociatedDocuments = () => {
    setReceiptData((prev) => {
      const lastAssociatedDocuments =
        prev.associated_documents[prev.associated_documents?.length - 1];

      if (!lastAssociatedDocuments) {
        return {
          ...prev,
          associated_documents: [{ associated_id: "", value: "" }],
        };
      }

      if (
        !lastAssociatedDocuments.associated_id ||
        !lastAssociatedDocuments.value
      ) {
        toast.error(
          "Please complete associate,value before adding another associated documents",
        );
        return prev;
      }

      return {
        ...prev,
        associated_documents: [
          ...prev.associated_documents,
          { associated_id: "", value: "" },
        ],
      };
    });
  };

  const handleRemoveAssociatedDocuments = (index) => {
    setReceiptData((prev) => {
      const updatedDocs = prev.associated_documents.filter(
        (_, i) => i !== index,
      );

      const totalNetValue = updatedDocs.reduce(
        (sum, d) => sum + (parseFloat(d.value) || 0),
        0,
      );

      return {
        ...prev,
        associated_documents: updatedDocs,
        net_value: totalNetValue.toFixed(2), // ✅ keep 2 decimals
        count: updatedDocs.length,
      };
    });
  };

  const handleChangeAssociatedDocuments = (index, field, value) => {
    setReceiptData((prev) => {
      const updatedDocs = [...prev.associated_documents];

      if (field === "associated_id") {
        if (!value) {
          updatedDocs[index] = { associated_id: "", value: "" };

          const totalNetValue = updatedDocs.reduce(
            (sum, d) => sum + (parseFloat(d.value) || 0),
            0,
          );

          return {
            ...prev,
            net_value: totalNetValue.toFixed(2),
            associated_documents: updatedDocs,
          };
        }

        const duplicateIndex = prev.associated_documents.findIndex(
          (doc, i) => doc.associated_id === value && i !== index,
        );
        if (duplicateIndex !== -1) {
          toast.error("Duplicate associated document not allowed");
          return prev;
        }

        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc) {
          if (selectedDoc.net_value) {
            updatedDocs[index].value = selectedDoc.net_value;
          }

          const totalNetValue = updatedDocs.reduce(
            (sum, d) => sum + (Number(d.value) || 0),
            0,
          );

          return {
            ...prev,
            net_value: totalNetValue,
            associated_documents: updatedDocs,
          };
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, associated_documents: updatedDocs };
    });

    setPropertyErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "associated_id" && !value) {
        errors[index].associated_id = "Associated is required";
      } else if (field === "associated_id") {
        errors[index].associated_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      return errors;
    });
  };

  const handleAddPayments = () => {
    setReceiptData((prev) => {
      const lastPayments = prev.payments[prev.payments?.length - 1];

      if (!lastPayments) {
        return {
          ...prev,
          payments: [{ payment_method_id: "", date: "", value: "", notes: "" }],
        };
      }

      if (
        !lastPayments.payment_method_id ||
        !lastPayments.value ||
        !lastPayments.date
      ) {
        toast.error(
          "Please complete payment method,value date, before adding another payment.",
        );
        return prev;
      }

      return {
        ...prev,
        payments: [
          ...prev.payments,
          { payment_method_id: "", date: "", value: "" },
        ],
      };
    });
  };

  const handleRemovePayments = (index) => {
    setReceiptData((prev) => ({
      ...prev,
      payments: prev.payments.filter((_, i) => i !== index),
    }));
  };

  const handleChangePayments = (index, field, value) => {
    setReceiptData((prev) => {
      const updatedDocs = [...prev.payments];

      if (field === "payment_method_id") {
        updatedDocs[index][field] = value;

        const selectedDoc = assocDataList.find((doc) => doc.value === value);

        if (selectedDoc && selectedDoc.net_value) {
          updatedDocs[index].value = selectedDoc.net_value;
        }
      } else {
        updatedDocs[index][field] = value;
      }

      return { ...prev, payments: updatedDocs };
    });

    setPaymentErrors((prevErrors) => {
      const errors = [...prevErrors];
      errors[index] = errors[index] || {};

      if (field === "payment_method_id" && !value) {
        errors[index].associated_id = "Payment Method is required";
      } else if (field === "payment_method_id") {
        errors[index].payment_method_id = "";
      }

      if (field === "value" && !value) {
        errors[index].value = "Value is required";
      } else if (field === "value") {
        errors[index].value = "";
      }

      if (field === "date" && !value) {
        errors[index].date = "Date is required";
      } else if (field === "date") {
        errors[index].date = "";
      }

      return errors;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let error = false;
    let errorObj = { ...errorsObj };
    // if (!receiptData?.date) {
    //   errorObj.date = `Date is required.`;
    //   error = true;
    //   setBtnLoader(false);
    // }

    if (!receiptData.net_value) {
      errorObj.net_value = `Net Value is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!receiptData.document_set_id) {
      errorObj.document_set_id = `Document Set is required.`;
      error = true;
      setBtnLoader(false);
    }

    if (!selectedCustomerId) {
      toast.error("Customer is required.");
      setBtnLoader(false);
    }

    // receiptData?.associated_documents?.forEach((tax, index) => {
    //   let rowError = {};

    //   if (!tax.associated_id) {
    //     rowError.associated_id = "Associate is required.";
    //     error = true;
    //   }
    //   if (!tax.value) {
    //     rowError.value = "Value is required.";
    //     error = true;
    //   }

    //   setBtnLoader(false);

    //   propertyErrors[index] = rowError;
    // });

    // receiptData?.payments?.forEach((item, index) => {
    //   let rowError = {};

    //   if (!item.payment_method_id) {
    //     rowError.payment_method_id = "Payment Method is required.";
    //     error = true;
    //   }
    //   if (!item.value) {
    //     rowError.value = "Value is required.";
    //     error = true;
    //   }

    //   if (!item.date) {
    //     rowError.date = "Date is required.";
    //     error = true;
    //   }

    //   setBtnLoader(false);

    //   paymentErrors[index] = rowError;
    // });

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;
    setBtnLoader(true);

    let data = {
      date: receiptData?.date,
      document_set_id: receiptData?.document_set_id,
      customer_id: selectedCustomerId,
      // alternate_address_id: receiptData?.alternate_address_id,
      associated_documents: JSON.stringify(receiptData?.associated_documents),
      related_documents_notes: receiptData?.related_documents_notes,
      notes: receiptData?.notes,
      status: receiptData?.status,
      net_value: receiptData?.net_value,
      payments: JSON.stringify(receiptData?.payments),
      associate_document_type: receiptData?.associate_document_type,
    };

    let updateData = {
      id: receiptData?.id,
      document_id: receiptData?.moloni_id,
      date: receiptData?.date,
      document_set_id: receiptData?.document_set_id,
      customer_id: selectedCustomerId,
      // alternate_address_id: receiptData?.alternate_address_id,
      associated_documents: JSON.stringify(receiptData?.associated_documents),
      related_documents_notes: receiptData?.related_documents_notes,
      exchange_currency_id: receiptData?.exchange_currency_id,
      exchange_rate: receiptData?.exchange_rate,
      // notes: receiptData?.notes,
      // status: receiptData?.status,
      net_value: receiptData?.net_value,
      payments: JSON.stringify(receiptData?.payments),
      associate_document_type: receiptData?.associate_document_type,
    };

    if (receiptDetials?.id) {
      updateReceipt(updateData)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/receipts");
          setReceiptData({
            id: "",
            moloni_id: "",
            date: "",
            document_set_id: "",
            customer_id: "",
            alternate_address_id: "",
            associated_documents: [],
            payments: [],
            related_documents_notes: "",
            exchange_currency_id: "",
            exchange_rate: "",
            notes: "",
            status: 0,
            net_value: "",
          });
          setBtnLoader(false);
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setBtnLoader(false);
        })
        .finally(() => {
          setBtnLoader(false);
        });
    } else {
      createSavereceipt(data)
        .then((response) => {
          toast.success(response.data.message);
          navigate("/receipts");
          setReceiptData({
            id: "",
            moloni_id: "",
            date: "",
            document_set_id: "",
            customer_id: "",
            alternate_address_id: "",
            associated_documents: [],
            payments: [],
            related_documents_notes: "",
            exchange_currency_id: "",
            exchange_rate: "",
            notes: "",
            status: 0,
            net_value: "",
          });
        })
        .catch((err) => {
          setBtnLoader(false);

          toast.error(Utils.getErrorMessage(err));
        })
        .finally(() => {
          setBtnLoader(false);
        });
    }
  };

  const handleCustomerSubmit = (e) => {
    e.preventDefault();

    if (!customerData.vat) {
      toast.error("Vat is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.number) {
      toast.error("Number is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.name) {
      toast.error("Name is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.language_id) {
      setActiveCustomerTab("4");
      toast.error("Language is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.address) {
      toast.error("Address is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.city) {
      toast.error("City is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.zip_code) {
      toast.error("Zip Code is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.country_id) {
      toast.error("Country is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.email) {
      toast.error("Email is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.phone) {
      toast.error("Phone is required.");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.maturity_date_id) {
      toast.error("Maturity Date is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    if (!customerData.payment_method_id) {
      toast.error("Payment Method is required.");
      setActiveCustomerTab("4");
      setIsModifyButtonLoad(false);
      return;
    }

    let data = {
      company_id: "269134",
      vat: customerData?.vat,
      number: customerData?.number,
      name: customerData?.name,
      language_id: customerData?.language_id,
      qty_copies_document: customerData?.qty_copies_document,
      notes: customerData?.notes,
      country_id: customerData?.country_id,
      address: customerData?.address,
      zip_code: customerData?.zip_code,
      city: customerData?.city,
      email: customerData?.email,
      website: customerData?.website,
      phone: customerData?.phone,
      fax: customerData?.fax,
      contact_name: customerData?.contact_name,
      contact_email: customerData?.contact_email,
      contact_phone: customerData?.contact_phone,
      discount: customerData?.discount,
      credit_limit: customerData?.credit_limit,
      payment_method_id: customerData?.payment_method_id,
      delivery_method_id: customerData?.delivery_method_id,
      maturity_date_id: customerData?.maturity_date_id,
      field_notes: customerData?.field_notes,
      salesman_id: customerData?.salesman_id,
      price_class_id: customerData?.price_class_id,
      payment_day: customerData?.payment_day,
      document_type_id: 0,
    };

    createListCustomer(data)
      .then((response) => {
        toast.success(response.data.message);

        setIsModifyButtonLoad(false);
        setCustomerData({
          id: "",
          vat: "",
          number: "",
          name: "",
          language_id: "",
          qty_copies_document: "",
          notes: "",
          country_id: "",
          address: "",
          zip_code: "",
          city: "",
          email: "",
          website: "",
          phone: "",
          fax: "",
          contact_name: "",
          contact_email: "",
          contact_phone: "",
          discount: "",
          credit_limit: "",
          payment_method_id: "",
          delivery_method_id: "",
          maturity_date_id: "",
          field_notes: "",
          salesman_id: "",
          price_class_id: "",
          payment_day: "",
          document_type_id: "",
          moloni_id: "",
        });

        setCustomerModel(false);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setIsModifyButtonLoad(false);
      });
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid container-custom-height-new">
            <div className="row mb-2">
              <div className="col-sm-12 d-flex align-items-center">
                <button
                  type="button"
                  className="next-button btn btn-secondary"
                  onClick={() => navigate("/moloni-document")}
                >
                  <i className="bi bi-arrow-left"></i> {t("back")}
                </button>
                <h1 className="page-title ms-auto mb-2">{t("receipts")}</h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="container-fluid container-custom-height-new">
            <div className="row justify-content-start">
              <div className="col-md-12">
                <Form method={`post`} onSubmit={handleSubmit}>
                  <div className="card card-primary">
                    <div className="card-body">
                      <div className="row justify-content-start">
                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("date")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="date"
                                  value={receiptData.date}
                                  onChange={(e) => {
                                    setReceiptData({
                                      ...receiptData,
                                      date: e.target.value,
                                    });
                                  }}
                                  name="date"
                                  placeholder="Select Date"
                                />
                              </div>
                              {errors.date && (
                                <span className="input-error">
                                  {errors.date}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("documentSet")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={documentSetList}
                                  value={documentSetList.find(
                                    (item) =>
                                      item.value ===
                                      receiptData.document_set_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setReceiptData({
                                      ...receiptData,
                                      document_set_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document Set"}
                                />
                                {errors.document_set_id && (
                                  <span className="input-error">
                                    {errors.document_set_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-3">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("net_value")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={receiptData.net_value}
                                  onChange={(e) => {
                                    setReceiptData({
                                      ...receiptData,
                                      net_value: e.target.value,
                                    });
                                  }}
                                  name="net_value"
                                  placeholder="Net Value"
                                />
                              </div>
                              {errors.net_value && (
                                <span className="input-error">
                                  {errors.net_value}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="row">
                          <div
                            className="card"
                            style={{
                              padding: "0px",
                              marginLeft: "15px",
                            }}
                          >
                            <div
                              className="card-header"
                              style={{
                                background: "#81bb42",
                                fontWeight: "600",
                              }}
                            >
                              {t("customers")}
                            </div>
                            <div className="card-body">
                              <div className="row">
                                <div
                                  className="col-md-9 position-relative"
                                  style={{
                                    // marginLeft: "-87px",
                                    padding: "15px",
                                  }}
                                >
                                  <input
                                    type="text"
                                    className="form-control pe-5"
                                    placeholder="Customers Search"
                                    value={search}
                                    onChange={(e) =>
                                      handleSearch(e.target.value)
                                    }
                                  />
                                  {search && (
                                    <i
                                      className="bi bi-x-circle-fill text-muted"
                                      style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                      }}
                                      onClick={() => handleSearch("")}
                                    ></i>
                                  )}
                                </div>

                                <div className="col-md-2 mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={() => setCustomerModel(true)}
                                  >
                                    {t("createCustomer")}{" "}
                                    <i className="bi bi-check2"></i>
                                  </button>
                                </div>

                                {filterList?.length > 0 && (
                                  <table className="table table-bordered mt-2">
                                    <thead>
                                      <tr>
                                        <th>Code</th>
                                        <th>Name</th>
                                        <th>Address</th>
                                        <th>VAT Number</th>
                                        <th>Product Price Table</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {filterList?.map((item, index) => (
                                        <tr
                                          key={index}
                                          style={{ cursor: "pointer" }}
                                          className={
                                            selectedCustomerId ===
                                            item.moloni_id
                                              ? "table-active"
                                              : ""
                                          }
                                          onClick={() =>
                                            handleSelectCustomer(item)
                                          }
                                        >
                                          <td>{item.moloni_id}</td>
                                          <td>{item.name}</td>
                                          <td>{item.address}</td>
                                          <td>{item.vat}</td>
                                          <td>
                                            {item.price_class_name || "-"}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("associated_documents")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddAssociatedDocuments}
                              type="button"
                            >
                              + {t("add")}
                            </button>
                            <div className="col-md-3">
                              <FormGroup>
                                <Label className="col-form-label ml-2 Label-my form-label form-label">
                                  {t("associate_document_type")}
                                </Label>
                                <Select
                                  className="my-select-v"
                                  options={invoiceType}
                                  value={invoiceType.find(
                                    (item) =>
                                      item.value ===
                                      receiptData.associate_document_type,
                                  )}
                                  onChange={(selectedOption) => {
                                    setReceiptData({
                                      ...receiptData,
                                      associate_document_type: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                    if (!selectedOption) {
                                      setAssocDataList([]);
                                      setReceiptData((prev) => ({
                                        ...prev,
                                        associated_documents: [],
                                        net_value: "",
                                      }));
                                    }
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Document type"}
                                />
                              </FormGroup>
                            </div>
                          </div>

                          {receiptData?.associated_documents?.length > 0 ? (
                            <div
                              className="row justify-content-start"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {receiptData?.associated_documents?.map(
                                (tax, index) => (
                                  <div className="col-md-6">
                                    <div className="fileupload-content px-4">
                                      <div
                                        className="row justify-content-start align-items-center mb-2"
                                        key={index}
                                      >
                                        <div className="col-md-6">
                                          <FormGroup>
                                            <Label className="col-form-label form-label">
                                              {t("associated_documents")}
                                            </Label>
                                            <div className="col-xl-12">
                                              <div className="input-div">
                                                <Select
                                                  className="my-select-v"
                                                  options={assocDataList}
                                                  value={
                                                    assocDataList.find(
                                                      (item) =>
                                                        item.value ===
                                                        tax.associated_id,
                                                    ) || null
                                                  }
                                                  onChange={(
                                                    selectedOption,
                                                  ) => {
                                                    handleChangeAssociatedDocuments(
                                                      index,
                                                      "associated_id",
                                                      selectedOption
                                                        ? selectedOption.value
                                                        : "",
                                                    );
                                                  }}
                                                  isSearchable={true}
                                                  isClearable={true}
                                                  placeholder={
                                                    "Select Associate"
                                                  }
                                                />
                                                {propertyErrors[index]
                                                  ?.associated_id && (
                                                  <small className="text-danger">
                                                    {
                                                      propertyErrors[index]
                                                        .associated_id
                                                    }
                                                  </small>
                                                )}
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>

                                        <div className="col-md-6">
                                          <FormGroup>
                                            <Label className="col-form-label form-label">
                                              {t("value")}
                                            </Label>
                                            <div className="col-xl-12">
                                              <div className="input-div">
                                                <input
                                                  className="form-control input-search"
                                                  type="number"
                                                  value={tax?.value}
                                                  onChange={(e) =>
                                                    handleChangeAssociatedDocuments(
                                                      index,
                                                      "value",
                                                      e.target.value,
                                                    )
                                                  }
                                                  placeholder="Value"
                                                />
                                                {propertyErrors[index]
                                                  ?.value && (
                                                  <small className="text-danger">
                                                    {
                                                      propertyErrors[index]
                                                        .value
                                                    }
                                                  </small>
                                                )}
                                              </div>
                                            </div>
                                          </FormGroup>
                                        </div>

                                        <div className="d-flex align-items-center">
                                          <button
                                            className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                            onClick={() =>
                                              handleRemoveAssociatedDocuments(
                                                index,
                                                tax,
                                              )
                                            }
                                            type="button"
                                          >
                                            <i className="bi bi-trash"></i>
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          ) : (
                            <p className="text-muted">
                              No Associated documents list added.
                            </p>
                          )}
                        </div>

                        <div className="row">
                          <div
                            className="col-md-12"
                            style={{
                              marginTop: "15px",
                              marginBottom: "15px",
                            }}
                          >
                            {" "}
                            <h5>{t("payments")}</h5>
                            <button
                              className="btn btn-primary"
                              onClick={handleAddPayments}
                              type="button"
                            >
                              + {t("add")}
                            </button>
                          </div>

                          {receiptData?.payments?.length > 0 ? (
                            <div
                              className="row justify-content-start"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                              }}
                            >
                              {receiptData?.payments?.map((tax, index) => (
                                <div className="col-md-6">
                                  <div className="fileupload-content px-4">
                                    <div
                                      className="row justify-content-start align-items-center mb-2"
                                      key={index}
                                    >
                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("payments")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <Select
                                                className="my-select-v"
                                                options={paymentList}
                                                value={
                                                  paymentList.find(
                                                    (item) =>
                                                      item.value ===
                                                      tax.payment_method_id,
                                                  ) || null
                                                }
                                                onChange={(selectedOption) => {
                                                  handleChangePayments(
                                                    index,
                                                    "payment_method_id",
                                                    selectedOption
                                                      ? selectedOption.value
                                                      : "",
                                                  );
                                                }}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder={"Select Payment"}
                                              />
                                              {paymentErrors[index]
                                                ?.payment_method_id && (
                                                <small className="text-danger">
                                                  {
                                                    paymentErrors[index]
                                                      .payment_method_id
                                                  }
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("date")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="date"
                                                value={tax?.date}
                                                onChange={(e) =>
                                                  handleChangePayments(
                                                    index,
                                                    "date",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Date"
                                              />
                                              {paymentErrors[index]?.date && (
                                                <small className="text-danger">
                                                  {paymentErrors[index].date}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("value")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <input
                                                className="form-control input-search"
                                                type="number"
                                                value={tax?.value}
                                                onChange={(e) =>
                                                  handleChangePayments(
                                                    index,
                                                    "value",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Value"
                                              />
                                              {paymentErrors[index]?.value && (
                                                <small className="text-danger">
                                                  {paymentErrors[index].value}
                                                </small>
                                              )}
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="col-md-6">
                                        <FormGroup>
                                          <Label className="col-form-label form-label">
                                            {t("notes")}
                                          </Label>
                                          <div className="col-xl-12">
                                            <div className="input-div">
                                              <textarea
                                                className="form-control input-search"
                                                type="text"
                                                value={tax.notes}
                                                onChange={(e) =>
                                                  handleChangePayments(
                                                    index,
                                                    "notes",
                                                    e.target.value,
                                                  )
                                                }
                                                placeholder="Notes"
                                              />
                                            </div>
                                          </div>
                                        </FormGroup>
                                      </div>

                                      <div className="d-flex align-items-center">
                                        <button
                                          className="btn btn-danger trash-btn-custom btn-sm ml-2"
                                          onClick={() =>
                                            handleRemovePayments(index, tax)
                                          }
                                          type="button"
                                        >
                                          <i className="bi bi-trash"></i>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <p className="text-muted">No Payment list added.</p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-3 mt-4">
                      <div className="col ms-2">
                        <button
                          type="button"
                          className="btn btn-primary mb-1"
                          onClick={() => navigate("/receipts")}
                        >
                          <i className="bi bi-arrow-left"> </i> {t("back")}
                        </button>
                      </div>
                      <div className="col">
                        <div className="d-flex justify-content-end nxt-btn">
                          {btnLoader === true ? (
                            <button
                              type="submit"
                              className="btn btn-primary mb-1"
                            >
                              Loading...
                            </button>
                          ) : (
                            <button
                              type="submit"
                              className="btn btn-primary mb-1"
                            >
                              {t("submit")} <i className="bi bi-check2"></i>
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </section>

        <Modal isOpen={customerModel} size="xl">
          <ModalHeader>{t("CreateCustomer")}</ModalHeader>
          <Form method={`post`}>
            <ModalBody>
              <div className="row">
                <div className="mb-3">
                  {/* Tabs */}
                  <ul className="custom-tabs">
                    <li
                      className={
                        activeCustomerTab === "1"
                          ? "tab-item active"
                          : "tab-item"
                      }
                      onClick={() => setActiveCustomerTab("1")}
                    >
                      {t("main")}
                    </li>

                    <li
                      className={
                        activeCustomerTab === "2"
                          ? "tab-item active"
                          : "tab-item"
                      }
                      onClick={() => setActiveCustomerTab("2")}
                    >
                      {t("contact")}
                    </li>

                    <li
                      className={
                        activeCustomerTab === "3"
                          ? "tab-item active"
                          : "tab-item"
                      }
                      onClick={() => setActiveCustomerTab("3")}
                    >
                      {t("otherAddresses")}
                    </li>

                    <li
                      className={
                        activeCustomerTab === "4"
                          ? "tab-item active"
                          : "tab-item"
                      }
                      onClick={() => setActiveCustomerTab("4")}
                    >
                      {t("billingSettings")}
                    </li>
                  </ul>

                  <div className="tab-content-area">
                    {activeCustomerTab === "1" && (
                      <div className="row">
                        <div class="alert alert-light" role="alert">
                          NOTE: All required fields are marked with{" "}
                          <span style={{ color: "red" }}>(*)</span>
                        </div>

                        <p>General Information</p>
                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("vat")} <span className="text-danger">*</span>
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.vat}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    vat: e.target.value,
                                  });
                                }}
                                name={`vat`}
                                maxLength={50}
                                placeholder="Vat"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("number")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.number}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    number: e.target.value,
                                  });
                                }}
                                name={`number`}
                                maxLength={50}
                                placeholder="Number"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("Name")} <span className="text-danger">*</span>
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.name}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    name: e.target.value,
                                  });
                                }}
                                name={`name`}
                                maxLength={50}
                                placeholder="Name"
                              />
                            </div>
                            {errors.name && (
                              <span className="input-error">{errors.name}</span>
                            )}
                          </FormGroup>
                        </div>
                        <div class="alert alert-primary" role="alert">
                          Fill with default data
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("address")}
                            </Label>
                            <span className="text-danger">*</span>

                            <div className="col-xl-12">
                              <textarea
                                className="form-control input-search"
                                type="text"
                                value={customerData.address}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    address: e.target.value,
                                  });
                                }}
                                name={`address`}
                                maxLength={50}
                                placeholder="Address"
                                rows={3}
                              />
                            </div>
                          </FormGroup>
                        </div>
                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("city")}
                            </Label>
                            <span className="text-danger">*</span>

                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.city}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    city: e.target.value,
                                  });
                                }}
                                name={`city`}
                                maxLength={50}
                                placeholder="City"
                              />
                            </div>
                          </FormGroup>
                        </div>
                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("zip_code")}
                            </Label>
                            <span className="text-danger">*</span>

                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.zip_code}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    zip_code: e.target.value,
                                  });
                                }}
                                name={`zip_code`}
                                maxLength={50}
                                placeholder="Zip code"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("country")}
                            </Label>
                            <span className="text-danger">*</span>

                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={countryList}
                                  value={countryList.find(
                                    (item) =>
                                      item.value == customerData.country_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setCustomerData({
                                      ...customerData,
                                      country_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Country"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("email")}
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.email}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    email: e.target.value,
                                  });
                                }}
                                name={`email`}
                                maxLength={50}
                                placeholder="Contact email"
                              />
                              {errors.email && (
                                <span className="input-error">
                                  {errors.email}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4" />
                      </div>
                    )}

                    {activeCustomerTab === "2" && (
                      <div className="row">
                        <div class="alert alert-light" role="alert">
                          NOTE: All required fields are marked with{" "}
                          <span style={{ color: "red" }}>(*)</span>
                        </div>

                        <p>Contacts</p>
                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("phone")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="input-div">
                              <input
                                className="form-control input-search"
                                type="number"
                                value={customerData.phone}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    phone: e.target.value,
                                  });
                                }}
                                name={`phone`}
                                placeholder="Phone"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("fax")}
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="number"
                                value={customerData.fax}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    fax: e.target.value,
                                  });
                                }}
                                name={`fax`}
                                placeholder="Fax"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("website")}
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.website}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    website: e.target.value,
                                  });
                                }}
                                name={`website`}
                                placeholder="website"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("contactPerson")}
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.contact_person}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    contact_person: e.target.value,
                                  });
                                }}
                                name={`contact_person`}
                                placeholder="Contact Person"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("contactEmail")}
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.contact_email}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    contact_email: e.target.value,
                                  });
                                }}
                                name={`contact_email`}
                                placeholder="Contact Email"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("telephoneContact")}
                            </Label>
                            <div className="col-xl-12">
                              <input
                                className="form-control input-search"
                                type="text"
                                value={customerData.telephone_contact}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    telephone_contact: e.target.value,
                                  });
                                }}
                                name={`telephone_contact`}
                                placeholder="Telephone Contact"
                              />
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-12">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my form-label form-label">
                              {t("contactNotes")}
                            </Label>
                            <div className="col-xl-12">
                              <textarea
                                className="form-control input-search"
                                type="text"
                                value={customerData.contact_notes}
                                onChange={(e) => {
                                  setCustomerData({
                                    ...customerData,
                                    contact_notes: e.target.value,
                                  });
                                }}
                                name={`contact_notes`}
                                placeholder="Contact Notes"
                                rows={4}
                              />
                            </div>
                          </FormGroup>
                        </div>
                      </div>
                    )}

                    {activeCustomerTab === "3" && (
                      <>
                        <div className="row">
                          <div className="alert alert-light" role="alert">
                            NOTE: All required fields are marked with{" "}
                            <span style={{ color: "red" }}>(*)</span>
                          </div>

                          <p>Alternate Address</p>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Description
                              </Label>
                              <span className="text-danger">*</span>

                              <input
                                className="form-control input-search"
                                type="text"
                                name="description"
                                value={altForm.description}
                                onChange={handleAltChange}
                                placeholder="Description"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Code
                              </Label>
                              <span className="text-danger">*</span>

                              <input
                                className="form-control input-search"
                                type="text"
                                name="code"
                                value={altForm.code}
                                onChange={handleAltChange}
                                placeholder="Code"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Zip Code
                              </Label>
                              <span className="text-danger">*</span>

                              <input
                                className="form-control input-search"
                                type="text"
                                name="zip_code"
                                value={altForm.zip_code}
                                onChange={handleAltChange}
                                placeholder="Zip Code"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                City
                              </Label>
                              <span className="text-danger">*</span>

                              <input
                                className="form-control input-search"
                                type="text"
                                name="city"
                                value={altForm.city}
                                onChange={handleAltChange}
                                placeholder="City"
                              />
                            </FormGroup>
                          </div>

                          {/* Country */}
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Country
                              </Label>
                              <span className="text-danger">*</span>

                              <Select
                                className="my-select-v"
                                options={countryList}
                                value={
                                  countryList.find(
                                    (item) => item.value === altForm.country,
                                  ) || null
                                }
                                onChange={(selectedOption) => {
                                  setAltForm({
                                    ...altForm,
                                    country: selectedOption
                                      ? selectedOption.value
                                      : "",
                                  });
                                }}
                                isSearchable={true}
                                isClearable={true}
                                placeholder="Select Country"
                              />
                            </FormGroup>
                          </div>

                          {/* Email */}
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                E-mail
                              </Label>
                              <input
                                className="form-control input-search"
                                type="text"
                                name="email"
                                value={altForm.email}
                                onChange={handleAltChange}
                                placeholder="Email"
                              />
                            </FormGroup>
                          </div>

                          {/* Phone */}
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Phone
                              </Label>
                              <input
                                className="form-control input-search"
                                type="text"
                                name="phone"
                                value={altForm.phone}
                                onChange={handleAltChange}
                                placeholder="Phone"
                              />
                            </FormGroup>
                          </div>

                          {/* Fax */}
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Fax
                              </Label>
                              <input
                                className="form-control input-search"
                                type="text"
                                name="fax"
                                value={altForm.fax}
                                onChange={handleAltChange}
                                placeholder="Fax"
                              />
                            </FormGroup>
                          </div>

                          {/* Contact Person */}
                          <div className="col-md-4">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Contact Person
                              </Label>
                              <input
                                className="form-control input-search"
                                type="text"
                                name="contact_person"
                                value={altForm.contact_person}
                                onChange={handleAltChange}
                                placeholder="Contact Person"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-12">
                            <FormGroup>
                              <Label className="col-form-label ml-2 Label-my form-label form-label">
                                Address
                              </Label>
                              <span className="text-danger">*</span>

                              <textarea
                                className="form-control input-search"
                                rows={4}
                                name="address"
                                value={altForm.address}
                                onChange={handleAltChange}
                                placeholder="Address"
                              />
                            </FormGroup>
                          </div>

                          <div className="col-md-12 mt-3">
                            <button
                              className="btn btn-primary"
                              onClick={saveAlternateAddress}
                              type="button"
                            >
                              {editIndex !== null
                                ? "Update Address"
                                : "Add Address"}
                            </button>
                          </div>
                        </div>

                        <div>
                          {receiptData?.alternate_address?.length > 0 && (
                            <table className="table table-bordered mt-4">
                              <thead>
                                <tr>
                                  <th>Code</th>
                                  <th>City</th>
                                  <th>Country</th>
                                  <th>Email</th>
                                  <th style={{ width: "120px" }}>Actions</th>
                                </tr>
                              </thead>

                              <tbody>
                                {receiptData?.alternate_address?.map(
                                  (item, index) => (
                                    <tr key={index}>
                                      <td>{item.code}</td>
                                      <td>{item.city}</td>
                                      <td>{item.country}</td>
                                      <td>{item.email}</td>
                                      <td>
                                        <div className="d-flex gap-2">
                                          <button
                                            className="btn btn-sm"
                                            type="button"
                                            onClick={() =>
                                              editAlternateAddress(index)
                                            }
                                          >
                                            <i className="bi bi-pencil"></i>
                                          </button>

                                          <button
                                            className="btn btn-sm"
                                            type="button"
                                            onClick={() =>
                                              deleteAlternateAddress(index)
                                            }
                                          >
                                            <i className="bi bi-trash3"></i>
                                          </button>
                                        </div>
                                      </td>
                                    </tr>
                                  ),
                                )}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </>
                    )}

                    {activeCustomerTab === "4" && (
                      <div className="row">
                        <div className="alert alert-light" role="alert">
                          NOTE: All required fields are marked with{" "}
                          <span style={{ color: "red" }}>(*)</span>
                        </div>

                        <p>Billing Settings</p>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("language")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={languageList}
                                  value={languageList.find(
                                    (item) =>
                                      item.value == customerData.language_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setCustomerData({
                                      ...customerData,
                                      language_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Language"}
                                />
                                {errors.language_id && (
                                  <span className="input-error">
                                    {errors.language_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("PriceTablesByDefault")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={priceClassList}
                                  value={priceClassList.find(
                                    (item) =>
                                      item.value == customerData.price_class_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setCustomerData({
                                      ...customerData,
                                      price_class_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Price Tables By Default"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("Maturity")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={maturityDatesList}
                                  value={maturityDatesList.find(
                                    (item) =>
                                      item.value ==
                                      customerData.maturity_date_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setCustomerData({
                                      ...customerData,
                                      maturity_date_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Maturity"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("payment_day")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={customerData.payment_day}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      payment_day: e.target.value,
                                    });
                                  }}
                                  name={`payment_day`}
                                  maxLength={50}
                                  placeholder="Payment day"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("globalDiscount")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={customerData.global_discount_id}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      global_discount_id: e.target.value,
                                    });
                                  }}
                                  name={`global_discount_id`}
                                  maxLength={50}
                                  placeholder="Global Discount"
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("credit_limit")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="number"
                                  value={customerData.credit_limit}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      credit_limit: e.target.value,
                                    });
                                  }}
                                  name={`credit_limit`}
                                  maxLength={50}
                                  placeholder="Credit limit"
                                />
                                {errors.credit_limit && (
                                  <span className="input-error">
                                    {errors.credit_limit}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("paymentMethod")}
                              <span className="text-danger">*</span>
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={paymentMethodList}
                                  value={paymentMethodList.find(
                                    (item) =>
                                      item.value ==
                                      customerData.payment_method_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setCustomerData({
                                      ...customerData,
                                      payment_method_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Payment Method"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("deliveryMethod")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={deliveryMethodList}
                                  value={deliveryMethodList.find(
                                    (item) =>
                                      item.value ==
                                      customerData.delivery_method_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setCustomerData({
                                      ...customerData,
                                      delivery_method_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Payment Method"}
                                />
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("salesmen")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <Select
                                  className="my-select-v"
                                  options={salesmenList}
                                  value={salesmenList.find(
                                    (item) =>
                                      item.value === customerData.salesman_id,
                                  )}
                                  onChange={(selectedOption) => {
                                    setCustomerData({
                                      ...customerData,
                                      salesman_id: selectedOption
                                        ? selectedOption.value
                                        : "",
                                    });
                                  }}
                                  isSearchable={true}
                                  isClearable={true}
                                  placeholder={"Select Salesmen"}
                                />
                                {errors.salesman_id && (
                                  <span className="input-error">
                                    {errors.salesman_id}
                                  </span>
                                )}
                              </div>
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4">
                          <FormGroup>
                            <Label className="col-form-label ml-2 Label-my">
                              {t("notes")}
                            </Label>
                            <div className="col-xl-12">
                              <div className="input-div">
                                <input
                                  className="form-control input-search"
                                  type="text"
                                  value={customerData.notes}
                                  onChange={(e) => {
                                    setCustomerData({
                                      ...customerData,
                                      notes: e.target.value,
                                    });
                                  }}
                                  name={`notes`}
                                  maxLength={50}
                                  placeholder="notes"
                                />
                              </div>
                              {errors.notes && (
                                <span className="input-error">
                                  {errors.notes}
                                </span>
                              )}
                            </div>
                          </FormGroup>
                        </div>

                        <div className="col-md-4" />
                        <div className="col-md-4" />
                        <div className="col-md-4" />
                        <div className="col-md-4" />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </ModalBody>
            <ModalFooter>
              <button
                type="button"
                className="btn btn-block btn-primary"
                disabled={isModifyButtonLoad}
                onClick={handleCustomerCloseModel}
                style={{ width: "100px", marginTop: "10px" }}
              >
                {t("close")} <i className="bi bi-x-lg"></i>
              </button>
              <button
                type="button"
                className="btn btn-primary"
                style={{ width: "120px" }}
                disabled={isModifyButtonLoad}
                onClick={handleCustomerSubmit}
              >
                {isModifyButtonLoad ? (
                  <>
                    <i className="fa fa-circle-o-notch fa-spin"></i> Loading...
                  </>
                ) : (
                  <>
                    {t("submit")} <i className="bi bi-check2"></i>
                  </>
                )}
              </button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
    </div>
  );
};

export default AddReceipt;
